var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostOverrunIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    fill: "#D1FFC1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9964 25.7135C36.5404 25.7135 37.81 26.9677 37.81 28.5184H41.1839C41.1839 25.7021 39.2739 23.3304 36.6891 22.5893V19.5449H33.3151V22.5893C30.7303 23.319 28.8203 25.7021 28.8203 28.5184C28.8203 31.9163 31.5881 34.6756 34.9964 34.6756C36.5404 34.6756 37.81 35.9298 37.81 37.4805C37.81 39.0198 36.5519 40.2854 34.9964 40.2854C33.4409 40.2854 32.1829 39.0312 32.1829 37.4805H28.8203C28.8203 40.2968 30.7303 42.6685 33.3151 43.4096V46.454H36.6891V43.4096C39.2739 42.6799 41.1839 40.2968 41.1839 37.4805C41.1839 34.0827 38.4161 31.3234 35.0078 31.3234C33.4638 31.3234 32.1943 30.0691 32.1943 28.5184C32.1829 26.9677 33.4524 25.7135 34.9964 25.7135Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 13C23.9768 13 15 21.9768 15 33C15 44.0232 23.9768 53 35 53C46.0232 53 55 44.0232 55 33C55 21.9768 46.0232 13 35 13ZM35 49.6648C25.8084 49.6648 18.3352 42.1916 18.3352 33C18.3352 23.8084 25.8084 16.3352 35 16.3352C44.1916 16.3352 51.6648 23.8084 51.6648 33C51.6648 42.1916 44.1916 49.6648 35 49.6648Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostOverrunIcon);
export default __webpack_public_path__ + "static/media/CostOverrunIcon.986fad582a8a9cdfe72050cdf8d343d9.svg";
export { ForwardRef as ReactComponent };